import TableOperationUtils from '../table-operation-utils';
function index(options) {
    return function (target, propertyName) {
        var property = TableOperationUtils.createPropertyInfo(propertyName);
        property.isIndex = true;
        property.isUnique = !!(options === null || options === void 0 ? void 0 : options.unique);
        TableOperationUtils.addTablePropertyInfo(target, property);
    };
}
export default index;
//# sourceMappingURL=indices.js.map